import type { Alert } from 'services/types/alert';

import baseApi from './baseApi';

const alertsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAlerts: build.query({
      query: () => ({
        url: `/alerts`,
        method: 'POST',
        body: { isArchived: false },
      }),
      transformResponse: (response: Alert[]) => response,
    }),
    readAlerts: build.mutation({
      query: (params: { alertIds: number[]; readAlert: boolean }) => ({
        url: `/alerts/readAlert`,
        method: 'POST',
        body: params,
      }),
      transformResponse: (response: { updatedAlertsCount: number }) => response,
    }),
    archiveAlerts: build.mutation({
      query: (params: { alertIds: number[]; archiveAlert: boolean }) => ({
        url: `/alerts/archiveAlert`,
        method: 'POST',
        body: params,
      }),
      transformResponse: (response: { updatedAlertsCount: number }) => response,
    }),
  }),
  overrideExisting: false,
});

export const { useGetAlertsQuery, useReadAlertsMutation, useArchiveAlertsMutation } = alertsApi;
